import { render, staticRenderFns } from "./EyeLensPanel.vue?vue&type=template&id=45065f9c&scoped=true&"
import script from "./EyeLensPanel.vue?vue&type=script&lang=js&"
export * from "./EyeLensPanel.vue?vue&type=script&lang=js&"
import style0 from "./EyeLensPanel.vue?vue&type=style&index=0&id=45065f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45065f9c",
  null
  
)

export default component.exports